import { render, staticRenderFns } from "./userLessons.vue?vue&type=template&id=6a81ed35&scoped=true&"
import script from "./userLessons.vue?vue&type=script&lang=ts&"
export * from "./userLessons.vue?vue&type=script&lang=ts&"
import style0 from "./userLessons.vue?vue&type=style&index=0&id=6a81ed35&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a81ed35",
  null
  
)

export default component.exports